import React, { useCallback } from 'react'
import Input from 'src/components/base/Input'
import produce from 'immer'
import { Jetty } from 'src/types'

import ProductHolderModal, { BaseProductHolder } from './ProductHolderModal'
import { getJettyErrors } from '../utils'

export type TPropsJettyModal = {
  selectedJetty: Jetty | null
  isOpen: boolean
  onJettyConfirm: (jetty: Jetty | undefined) => void
  onCancel?: () => void
}

function JettyModal({ selectedJetty, onJettyConfirm, isOpen, onCancel }: TPropsJettyModal) {
  return (
    <ProductHolderModal<Jetty & BaseProductHolder>
      selected={selectedJetty as Jetty}
      isOpen={isOpen}
      onConfirm={onJettyConfirm}
      onCancel={onCancel}
      subjectName="jetty"
      idPrefix="jetty"
      validateEntity={getJettyErrors as (e: Jetty) => string[]}
      renderTopFields={({ entity, setEntity }) => (
        <>
          <Input
            label="Bollard"
            id="bollard"
            type="number"
            value={(entity as Jetty)?.bollard ?? ''}
            onChange={e => {
              const newBollard = Number(e.target.value)
              setEntity(draft => {
                draft.bollard = newBollard
              })
            }}
            required
            parentStyle={{ flex: 1 }}
            flexibleWidth
          />
          <div style={{ flex: 1 }} />
        </>
      )}
    />
  )
}

export default JettyModal
